// extracted by mini-css-extract-plugin
export var brand = "_3q-9";
export var compact = "_3q-6";
export var extraSmall = "_3q-7";
export var icon = "_3q-0";
export var large = "_3q-4";
export var light = "_3q-1";
export var medium = "_3q-5";
export var outline = "_3q-b";
export var primaryDark = "_3q-a";
export var primaryLight = "_3q-8";
export var primaryModern = "_3q-c";
export var success = "_3q-2";
export var successSolid = "_3q-3";